import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import 'babel-polyfill'
import 'nodelist-foreach-polyfill'
import styled, { injectGlobal } from 'styled-components'
import Footer from '../components/footer'

import '../../static/fonts/fonts.css'

import '../style/css.js'

import * as vars from '../style/vars'
import { below } from '../style/functions'
import TagManager from 'react-gtm-module'

import Header from '../components/header.js'
class TemplateWrapper extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			page_title: 'YarraBend: Off the Plan Townhouses, Apartments & Property Melbourne',
			page_description:
				'Luxury Glenvill homes, townhouses, apartments, on the edge of Kew, just 6.5km fr' +
				'om Melbourne CBD. An iconic new suburb of world class living.',
			page_slug: null,
			page_type: null,
			isIE: null,
			utm: {
				utm_source: null,
				utm_medium: null,
				utm_campaign: null,
				referrer: null,
			},

			form_first_name: null,
			form_last_name: null,
			form_phone: null,
			form_email: null,
			form_property: null,

			popupVisible: false,
			productHide: false,
			footerVisible: true,
		}
	}

	componentDidMount() {
		const tagManagerArgs = {
			gtmId: 'GTM-5H96W82',
		}
		TagManager.initialize(tagManagerArgs)

		if (typeof window !== `undefined`) {
			if (window.location.pathname == '/enquire') {
				this.setState({ hideenquiry: 'enquire' })
			}

			if (window.location.pathname == '/offer') {
				this.setState({ hideFooter: true })
			} else {
				this.setState({ hideFooter: false })
			}

			let params = queryString.parse(this.props.location.search)
			if (NODE_ENV === 'dev') {
				// console.log(params);
			}
			//this.queryForm();

			if (
				params.utm_campaign ||
				params.utm_source ||
				params.utm_medium ||
				document.referrer
			) {
				let utmCopy = JSON.parse(JSON.stringify(this.state.utm))
				utmCopy.utm_campaign = params.utm_campaign
				utmCopy.utm_source = params.utm_source
				utmCopy.utm_medium = params.utm_medium
				utmCopy.referrer = document.referrer
				this.setState({ utm: utmCopy })
			}

			this.setState({ isIE: /*@cc_on!@*/ false || !!document.documentMode })
			setTimeout(function() {
				window.scrollTo(0, 0)
			}, 1)

			/*
			const navs = document.querySelectorAll('a');
      let href;
      if (typeof window !== `undefined`) {

        navs
          .forEach(function (item, index) {
            if (document.location.href == item.href) {
              item
                .classList
                .add('active');
            }
          });
			}
			*/
		}
		const { NODE_ENV } = process.env

		if (NODE_ENV === 'dev') {
			const script1 = document.createElement('script')
			script1.src =
				'https://storage.googleapis.com/proj.insitelogic.com.au/tracker/insite.min.js'
			script1.async = false
			document.body.appendChild(script1)

			const script2 = document.createElement('script')
			script2.src =
				'https://storage.googleapis.com/proj.insitelogic.com.au/tracker/glenvill/yarrabend.js'
			script2.async = false
			document.body.appendChild(script2)
		} else {
			const script = document.createElement('script')
			script.src = 'https://trackingcore-service-dot-insite-projects.appspot.com/core'
			script.async = false
			document.body.appendChild(script)
		}
	}

	// queryForm() {

	//   let reset = false
	//   let self = window.location.toString();
	//   let querystring = self.split("?");
	//   if (querystring.length > 1) {
	//     let pairs = querystring[1].split("&");
	//     if (pairs.length > 0) {
	//       var obj = {}
	//       for (var i = 0; i < pairs.length; i++) {
	//         let keyval = pairs[i].split("=");
	//         //console.log(keyval);
	//         let key = keyval[0];
	//         let val = keyval[1];
	//         obj[key] = val;

	//       }

	//       this.setState({ utm: obj });
	//     }
	//   }

	// }

	updateMeta(title, desc) {
		this.setState({ page_title: title, page_description: desc })
	}

	togglePopup(state) {
		if (state != null) {
			this.setState({ popupVisible: state })
		} else {
			this.setState({ popupVisible: !this.state.popupVisible })
		}
	}

	updateSlug(slug) {
		this.setState({ page_slug: slug })
	}

	updateProductHide(bool) {
		this.setState({ productHide: bool })
	}

	updatePageType(type) {
		this.setState({ page_type: type })
	}

	updateFormDetails(first_name, last_name, phone, email, property = null) {
		this.setState({
			form_first_name: first_name,
			form_last_name: last_name,
			form_phone: phone,
			form_email: email,
			form_property: property,
		})
	}

	updateFooterVisible(visible = true) {
		this.setState({ footerVisible: visible })
	}

	render() {
		const updateMeta = this.updateMeta.bind(this)

		const updateSlug = this.updateSlug.bind(this)

		const updatePageType = this.updatePageType.bind(this)

		const togglePopup = this.togglePopup.bind(this)

		const updateFormDetails = this.updateFormDetails.bind(this)

		const updateFooterVisible = this.updateFooterVisible.bind(this)

		const updateProductHide = this.updateProductHide.bind(this)
		return (
			<div id='wrapper'>
				<Helmet
					title={this.state.page_title}
					meta={[
						{
							charset: 'utf-8',
						},
						{
							name: 'viewport',
							content: 'width=device-width, initial-scale=1',
						},
						{
							http_equiv: 'x-ua-compatible',
							content: 'IE=edge,chrome=1',
						},
						{
							name: 'description',
							content: this.state.page_description,
						},
						{
							itemprop: 'name',
							content: this.state.page_title,
						},
						{
							itemprop: 'description',
							content: this.state.page_description,
						},
						{
							name: 'twitter:card',
							content: 'summary_large_image',
						},
						{
							name: 'twitter:title',
							content: this.state.page_title,
						},
						{
							name: 'twitter:description',
							content: this.state.page_description,
						},
						{
							property: 'og:title',
							content: this.state.page_title,
						},
						{
							property: 'og:type',
							content: 'website',
						},
						{
							property: 'og:url',
							content: `https://yarrabend.com.au${this.props.location_pathname}`,
						},
						{
							property: 'og:description',
							content: this.state.page_description,
						},
						{
							property: 'og:site_name',
							content: 'YarraBend',
						},
						{
							name: 'theme-color',
							content: '#3f3e3e',
						},
						{
							property: 'business:contact_data:street_address',
							content: '700 Heidelberg Rd',
						},
						{
							property: 'business:contact_data:locality',
							content: 'Alphington',
						},
						{
							property: 'business:contact_data:region',
							content: 'VIC',
						},
						{
							property: 'business:contact_data:postal_code',
							content: '3078',
						},
						{
							property: 'business:contact_data:country_name',
							content: 'AU',
						},
						{
							property: 'business:contact_data:phone_number',
							content: '+61 (0)3 9573 8320',
						},
						{
							property: 'business:contact_data:website',
							content: 'https://yarrabend.com.au',
						},
						{
							property: 'place:location:latitude',
							content: '-37.781251',
						},
						{
							property: 'place:location:longitude',
							content: '145.029669',
						},
					]}
					link={[
						{
							rel: 'canonical',
							href: 'https://yarrabend.com.au',
						},
					]}
					script={[
						{
							'@context': 'http://schema.org',
							'@type': 'Place',
							url: 'https://yarrabend.com.au',
							logo: `https://yarrabend.com.au/images/favicon.png`,
							address: {
								'@type': 'PostalAddress',
								streetAddress: '700 Heidelberg Rd',
								addressLocality: 'Alphington',
								addressRegion: 'VIC',
								addressCountry: 'AU',
								postalCode: '3078',
							},
							amenityFeature: 'Housing Development',
							geo: {
								'@type': 'GeoCoordinates',
								latitude: '-37.781251',
								longitude: '145.029669',
							},
							telephone: '+61 (0)3 9573 8320',
							description: 'The Worlds Most Liveable Suburb',
							parentOrganization: 'http://glenvill.com.au/',
							openingHoursSpecification: [
								{
									'@type': 'OpeningHoursSpecification',
									closes: '17:00:00',
									dayOfWeek: 'http://schema.org/Sunday',
									opens: '11:00:00',
								},
								{
									'@type': 'OpeningHoursSpecification',
									closes: '17:00:00',
									dayOfWeek: 'http://schema.org/Saturday',
									opens: '11:00:00',
								},
								{
									'@type': 'OpeningHoursSpecification',
									closes: '17:00:00',
									dayOfWeek: 'http://schema.org/Thursday',
									opens: '12:00:00',
								},
								{
									'@type': 'OpeningHoursSpecification',
									closes: '17:00:00',
									dayOfWeek: 'http://schema.org/Tuesday',
									opens: '12:00:00',
								},
								{
									'@type': 'OpeningHoursSpecification',
									closes: '17:00:00',
									dayOfWeek: 'http://schema.org/Friday',
									opens: '12:00:00',
								},
								{
									'@type': 'OpeningHoursSpecification',
									closes: '17:00:00',
									dayOfWeek: 'http://schema.org/Monday',
									opens: '12:00:00',
								},
								{
									'@type': 'OpeningHoursSpecification',
									closes: '17:00:00',
									dayOfWeek: 'http://schema.org/Wednesday',
									opens: '12:00:00',
								},
							],
							sameAs: [
								'https://www.facebook.com/yarrabend',
								'https://www.instagram.com/yarrabend_/',
							],
						},
					]}
				>
					<meta
						name='facebook-domain-verification'
						content='4lddsvlcp3amirnfci1ov3vklloz4q'
					/>
				</Helmet>
				{this.props.children({
					...this.props,
					...this.state,
					updateMeta,
					updateSlug,
					updateFormDetails,
					togglePopup,
					updatePageType,
					updateProductHide,
					updateFooterVisible,
				})}

				{this.state.footerVisible === true && (
					<Footer
						productHide={this.state.productHide}
						type={this.state.page_type}
						utm={this.state.utm}
						slug={this.state.page_slug}
						updateFormDetails={(first_name, last_name, phone, email, property) =>
							this.updateFormDetails(first_name, last_name, phone, email, property)
						}
					/>
				)}
			</div>
		)
	}
}

TemplateWrapper.propTypes = {
	children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js